import type {CardsPlayed, CardType} from '$lib/gojiras';
import {clone} from '$lib/gojiras';
import {writable} from 'svelte/store';

export type StakeDeck = {
  cardsPlayed: CardsPlayed<{attributeIndex: number; cardIndex: number} | undefined, CardType | undefined>;
};

export const emptyDeck: StakeDeck = {
  cardsPlayed: {
    gojiraCards: [undefined, undefined, undefined, undefined, undefined],
    baseCards: [undefined, undefined, undefined, undefined, undefined],
    // gojiraCards: [
    //   {attributeIndex: 0, cardIndex: 0},
    //   {attributeIndex: 1, cardIndex: 0},
    //   {attributeIndex: 2, cardIndex: 0},
    //   {attributeIndex: 3, cardIndex: 0},
    //   {attributeIndex: 4, cardIndex: 0},
    // ],
    // baseCards: [0, 1, 2, 3, 4],
  },
};

const stakeDeck = writable<StakeDeck>(clone(emptyDeck));

export {stakeDeck};
